export enum AppEvents {
    BUY_ITEM = 'BUY_ITEM',
    PURCHASE_COMPLETED = 'PURCHASE_COMPLETED',
    PURCHASE_CANCELED = 'PURCHASE_CANCELED',
    PURCHASE_FAILED = 'PURCHASE_FAILED',
    SHOW_SELECT_GAME_TO_PLAY = 'SHOW_SELECT_GAME_TO_PLAY',
    SHOW_LOOT_BOX = 'SHOW_LOOT_BOX',
}